import { Directive, EventEmitter, Output } from '@angular/core';

@Directive()
export class MSPDashboardV2Component {
  @Output() isFetchingKpis = new EventEmitter<boolean>();
}
